import React from "react"
import types from "prop-types"
import { categoryShape } from "utils/propTypeShapes"
import ItemRow from "shared/ItemRow"
import UserInfo from "shared/UserInfo"
import { CircularIconButton } from "shared/buttons"
import AccessLevelIdentifier from "./AccessLevelIdentifier"

const UserGranteeList = ({
  category, users, updateAccessGranteeLists, deleteAccessLevelGrant,
}) => {
  if (!users.length) {
    return <div className="m-5">No Users with Grants</div>
  }

  return users.map(({ id, grantee, accessLevel }) => (
    <ItemRow
      key={id}
      itemRowHeaderContent={(
        <div className="flex flex-row items-center justify-between gap-4 w-full">
          <UserInfo user={grantee} showContentIfInactive={false} />
          <AccessLevelIdentifier
            category={category}
            grantId={id}
            updateAccessGranteeLists={updateAccessGranteeLists}
            granteeType="User"
            granteeId={grantee.id}
            accessLevel={accessLevel}
            selectLabel={`select access level for ${grantee.fullName}`}
          />
        </div>
      )}
      itemRowHeaderControls={(
        <CircularIconButton
          ariaLabel="delete user access level grant"
          icon="close"
          onClick={deleteAccessLevelGrant(id)}
        />
      )}
    />
  ))
}

UserGranteeList.propTypes = {
  category: categoryShape.isRequired,
  users: types.arrayOf(types.object).isRequired,
  updateAccessGranteeLists: types.func.isRequired,
  deleteAccessLevelGrant: types.func.isRequired,
}

export default UserGranteeList
